import React from 'react'

const Heading = (props) => {
    return (
        <div className={`heading-block ${(props.color ? props.color : '')}`}>
            <div className='row'>
                <div className={`${props.children ? 'col-md-5' : ''} col-12`}>
                    <h2 dangerouslySetInnerHTML={{ __html: props.title }} />
                </div>
                {props.children}
            </div>

        </div>
    )
}

export default Heading



// WEBPACK FOOTER //
// ./resources/js/components/Heading.js